import {
  RedoModal,
  RedoModalButtonProps,
} from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

export const ConfirmDeleteSupportV2FolderModal = memo(
  function ConfirmDeleteSupportV2FolderModal({
    isOpen,
    onClose,
    onSubmit,
    folderName,
  }: {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => Promise<void>;
    folderName: string;
  }) {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
      try {
        setIsSubmitting(true);
        await onSubmit();
        onClose();
      } finally {
        setIsSubmitting(false);
      }
    };

    const primaryButton: RedoModalButtonProps = {
      text: "Delete",
      onClick: handleSubmit,
      disabled: isSubmitting,
      theme: "destructive",
    };

    const secondaryButton: RedoModalButtonProps = {
      text: "Cancel",
      onClick: onClose,
      disabled: isSubmitting,
      pending: false,
    };

    return (
      <RedoModal
        buttonPlacement="full"
        isOpen={isOpen}
        onModalCloseRequested={isSubmitting ? () => {} : onClose}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
        title="Delete folder"
      >
        <Flex dir="column" gap="xl">
          <Text>
            Are you sure you want to delete the folder "{folderName}"? Views in
            this folder will not be deleted.
          </Text>
        </Flex>
      </RedoModal>
    );
  },
);
